{
  "home" : {
    "meta": {
      "title": "Ahorra dinero con banca móvil para migrantes - MAJORITY",
      "description": "Hazte miembro de Majority la Banca Móvil todo en uno para migrantes. Ahorra dinero, envía, recarga y habla a través de la aplicación ¡Visítanos y descubre más!"
    },
    "hero": {
      "title": "¿Necesitas enviar dinero? Descubre la App para enviar dinero y más",
      "body": "Ahorra dinero, envía, recarga y habla con la app Majority",
      "cta": "Comenzar"
    },
    "services": {
      "title": "¿Qué incluye?",
      "subtitle": "¡TODOS ESTOS SERVICIOS EN UNA APP POR SOLO ${appPrice} AL MES!",
      "cta": "Ver todos los beneficios"
    },
    "account_content_box": {
      "tagline": "Cuenta de MAJORITY",
      "title": "Banca móvil para recibir tu sueldo antes",
      "body": "Regístrate para el depósito directo y recibe tu sueldo hasta dos días antes. Tu cuenta MAJORITY tiene todas las funciones que necesitas sin cargos extra y te ahorra dinero!"
    },
    "visa_content_box": {
      "tagline": "Tarjeta** de Débito Visa®",
      "title": "Descuentos en comercios locales",
      "body": "Obtén recompensas por apoyar a los comercios locales. Consulta nuestros increíbles descuentos en restaurantes y supermercados locales y muchos lugares más. Compra con orgullo y ahorra dinero con la tarjeta de débito Visa® MAJORITY."
    },
    "remittance_content_box": {
      "tagline": "Envíos de dinero",
      "title": "AHORRA MÁS CON ENVÍOS SIN CARGOS OCULTOS",
      "body": "Envía dinero al extranjero de forma rápida y segura. Nunca ha sido más fácil o más asequible enviar dinero a casa."
    },
    "community_content_box": {
      "title": "Una comunidad conectada",
      "body": "La app de MAJORITY Banca Móvil es desarrollada por migrantes, para migrantes. Sabemos lo difícil que es mudarse a un lugar nuevo, por eso te traemos un poco de tu hogar. Todos los servicios y las funciones de MAJORITY se crearon teniendo en cuenta tus necesidades.\n\nTu membresía MAJORITY también te conecta con otros en tu comunidad. Lee historias inspiradoras y recursos para migrantes sobre cómo adaptarse a la vida en los EUA. Además, ¡obtén acceso exclusivo a eventos, descuentos locales y más en tu barrio! ¡Ahorra dinero ya!",
      "cta": "Conectar con la comunidad"
    },
    "mtu_content_box": {
      "tagline": "Recargas móviles",
      "title": "Recargas instantáneas y gratis",
      "body": "Recargas. Tiempo aire. Saldo. Como lo quieras llamar, puedes recargar a cualquiera en casa por menos con MAJORITY.\n* Ahorra dinero con envíos sin cargos\n* Entrega instantánea y segura\n* Promociones especiales a Cuba y más"
    },
    "calling_content_box": {
      "tagline": "Llamadas Internacionales",
      "title": "Llamadas ilimitadas y gratis a más de 20 países",
      "body": "Haz llamadas gratis e ilimitadas a México, Colombia, Canadá, Reino Unido y más de 20 países. Llama a Nigeria, Cuba y cualquier otro país del mundo con las tarifas más bajas y con conexiones de alta calidad.\n* Llama a cualquier teléfono móvil o fijo\n* Conexiones de alta calidad\n* No se requiere internet"
    },
    "advisor_content_box": {
      "tagline": "Asesores personales",
      "title": "Un asesor solo para ti",
      "body": "En MAJORITY hablamos tu idioma. Con nuestra banca móvil conoce a un asesor personalizado que pueda responder tus preguntas en tu propio idioma. Además, como parte de nuestra comunidad, obtén acceso a contenido, consejos y eventos exclusivos."
    }
  }
  
}